import React from "react";
import { CheckIcon } from "@heroicons/react/solid";
import { bone, paw } from "../../assets/svg";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ProgressBar({ step, setStep, barSteps }, petType) {
  const selectStep = (no, status) => {
    {
      if (status === "complete") {
        setStep(no);
      }
      if (status === "current") {
        setStep(no);
      }
    }
  };

  return (
    <div className="flex justify-center h-full items-center bg-[#FF8C01] sm:justify-around">
      {petType === 'dog' && <img
        className="hidden h-8 md:flex  md:h-12 lg:h-16"
        src={bone}
        alt={bone}
      />}
      {petType === 'cat' && <img
        className="hidden h-8 md:flex  md:h-12 lg:h-16"
        src={bone}
        alt={bone}
      />}
      
      <nav aria-label="Progress" className="">
        <ol role="list" className="flex items-center">
          {barSteps.map((step, stepIdx) => (
            <li
              key={step.name}
              className={classNames(
                stepIdx !== barSteps.length - 1 ? "pr-8 sm:pr-20" : "",
                "relative"
              )}
            >
              {step.status === "complete" ? (
                <>
                  <div
                    className="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div className="h-0.5 w-full bg-lime-600" />
                  </div>
                  <a
                    onClick={() => {
                      selectStep(step.name, step.status);
                    }}
                    className="relative w-8 h-8 flex items-center justify-center bg-lime-600 rounded-full hover:bg-lime-900"
                  >
                    <CheckIcon
                      className="w-5 h-5 text-white"
                      aria-hidden="true"
                    />
                    <span className="sr-only">{step.name}</span>
                  </a>
                </>
              ) : step.status === "current" ? (
                <>
                  <div
                    className="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div className="h-0.5 w-full bg-gray-200" />
                  </div>
                  <a
                    onClick={() => selectStep(step.name, step.status)}
                    className="relative w-8 h-8 flex items-center justify-center bg-white border-2 border-lime-600 rounded-full"
                    aria-current="step"
                  >
                    <span
                      className="h-2.5 w-2.5 bg-lime-600 rounded-full"
                      aria-hidden="true"
                    />
                    <span className="sr-only">{step.name}</span>
                  </a>
                </>
              ) : (
                <>
                  <div
                    className="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div className="h-0.5 w-full bg-gray-200" />
                  </div>
                  <a className="group relative w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full hover:border-gray-400">
                    <span
                      className="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"
                      aria-hidden="true"
                    />
                    <span className="sr-only">{step.name}</span>
                  </a>
                </>
              )}
            </li>
          ))}
        </ol>
      </nav>
      {petType === 'dog' && <img
        className="hidden h-8 md:flex  md:h-12 lg:h-16"
        src={paw}
        alt={paw}
      />}
      {petType === 'cat' && <img
        className="hidden h-8 md:flex  md:h-12 lg:h-16"
        src={paw}
        alt={paw}
      />}
      
    </div>
  );
}

export default ProgressBar;
